import * as React from "react";
import { Card, CardContent } from "../ui/card";
import {
  ArrowDown,
  ArrowUp,
  Briefcase,
  Calendar,
  FileText,
  Trophy,
} from "lucide-react";

const StudentRankingStats = ({ myRanking, rankingData }) => {
  // const { myRanking } = useSelector((state) => state.ranking);

  // const rankingData = myRanking.ranking;
  const rankChange = rankingData?.rankChange || 0;

  const performanceData = [
    {
      name: "Attendance",
      value: Math.round(rankingData?.attendanceScore || 0),
      color: "#6366f1",
    },
    {
      name: "Interviews",
      value: Math.round(rankingData?.interviewScore || 0),
      color: "#8b5cf6",
    },
    {
      name: "Assignments",
      value: Math.round(rankingData?.assignmentScore || 0),
      color: "#16A34A",
    },
    {
      name: "Daily Tasks",
      value: Math.round(rankingData?.taskScore || 0),
      color: "#f59e0b",
    },
  ];

  const overallScore = Math.round(rankingData?.totalScore || 0);
  const currentRank = rankingData?.rank || 0;
  const totalStudents = myRanking?.data?.totalStudents || 0;
  const percentile = myRanking?.data?.percentile || 0;

  return (
    <div className="grid grid-cols-1  md:grid-cols-4 gap-4">
      {/* Overall Score Card */}
      <Card className="bg-gradient-to-br dark:from-green-700 dark:to-green-800 from-green-500 to-green-600 text-white  border-0 shadow-lg">
        <CardContent className="pt-3">
          <div className="flex items-center justify-between mb-2">
            <Trophy className="w-8 h-8 opacity-80" />
            <div className="inline-flex items-center  px-2 py-1 rounded-full bg-white/20 text-white text-xs font-medium border border-white/30 shadow-sm backdrop-blur-md hover:bg-white/30 transition">
              🏅 Rank {currentRank} / {totalStudents}
            </div>
          </div>
          <div className="text-4xl font-bold mb-1">{overallScore}%</div>
          <p className="text-green-100 text-sm">Overall Performance</p>
          <div className="flex items-center gap-1 mt-3 text-sm">
            {rankChange > 0 ? (
              <>
                <ArrowUp className="w-4 h-4" />
                <span>
                  Up {rankChange} rank{rankChange !== 1 ? "s" : ""}
                </span>
              </>
            ) : rankChange < 0 ? (
              <>
                <ArrowDown className="w-4 h-4" />
                <span>
                  Down {Math.abs(rankChange)} rank
                  {Math.abs(rankChange) !== 1 ? "s" : ""}
                </span>
              </>
            ) : (
              <span>No change</span>
            )}
          </div>
          <div className="mt-2 text-xs text-green-100">
            {percentile}th percentile
          </div>
        </CardContent>
      </Card>

      {/* Metric Cards */}
      {performanceData.slice(0, 3).map((metric, index) => {
        const icons = [Calendar, Briefcase, FileText];
        const Icon = icons[index];

        // Calculate realistic change indicators
        // const predictions = rankingData?.predictions;
        // const weights = rankingData?.weights;
        let change = 0;

        if (index === 0) {
          // Attendance
          change = metric.value >= 70 ? 3 : -2;
        } else if (index === 1) {
          // Interviews
          change = metric.value >= 50 ? 2 : -3;
        } else if (index === 2) {
          // Assignments
          change = metric.value >= 50 ? 5 : -1;
        }

        return (
          <Card
            key={metric.name}
            className="bg-gradient-to-br dark:from-gray-800 dark:to-gray-950 from-white to-gray-50/50 border border-gray-100 hover:shadow-lg hover:border-gray-200 transition-all duration-300 group"
          >
            <CardContent className="pt-6 pb-5">
              <div className="flex items-center justify-between mb-4">
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow"
                  style={{ backgroundColor: `${metric.color}15` }}
                >
                  <Icon className="w-5 h-5" style={{ color: metric.color }} />
                </div>
                <div
                  className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs font-semibold ${
                    change > 0
                      ? "text-green-600 bg-green-50"
                      : change < 0
                      ? "text-red-600 bg-red-50"
                      : "text-gray-600 bg-gray-50"
                  }`}
                >
                  {change > 0 ? (
                    <ArrowUp className="w-3 h-3" />
                  ) : change < 0 ? (
                    <ArrowDown className="w-3 h-3" />
                  ) : null}
                  <span>{change !== 0 ? `${Math.abs(change)}%` : "0%"}</span>
                </div>
              </div>
              <div className="text-3xl font-bold dark:text-foreground text-gray-900 mb-1">
                {metric.value}%
              </div>
              <p className="text-sm dark:text-foreground text-gray-500 mb-3">
                {metric.name}
              </p>

              {/* Progress bar */}
              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500 ease-out"
                  style={{
                    width: `${metric.value}%`,
                    backgroundColor: metric.color,
                  }}
                />
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default StudentRankingStats;
